export const SHOW_TEXT = "RESPONSE_ERROR";
export const RESPONSE_ERROR = "RESPONSE_ERROR";
export const MEDICATION_CURRENT = "MEDICATION_CURRENT";
export const MEDICATION_EDITED = "MEDICATION_EDITED";
export const MEDICATION_CREATED = "MEDICATION_CREATED";
export const MEDICATION_SEARCHED = "MEDICATION_SEARCHED";
export const MEDICATION_SEARCH_REALIZED = "MEDICATION_SEARCH_REALIZED";
